import React from "react";
import RotatingKeyword from "./RotatingKeyword";

/**
 * Einheitlicher Seiten-Header im Habthek-Stil (dunkle Card mit Glow,
 * Eyebrow-Icon, Titel, rotierendem Schlagwort und Intro-Text).
 * `aside` wird rechts neben dem Textblock gerendert (z.B. Punktestand, Suche).
 */
export const PageHero = ({ eyebrow, icon: Icon, title, keywords = [], intro, aside = null, testId = "page-hero" }) => (
  <div className="relative overflow-hidden rounded-2xl border border-white/10 bg-[#0f141b] px-6 py-10 sm:px-10" data-testid={testId}>
    <div className="pointer-events-none absolute -right-24 -top-24 h-72 w-72 rounded-full bg-[#7c4dff]/20 blur-3xl" />
    <div className="pointer-events-none absolute -bottom-24 left-1/3 h-56 w-56 rounded-full bg-[#ff9800]/10 blur-3xl" />
    <div className="relative flex flex-col gap-6 md:flex-row md:items-end md:justify-between">
      <div className="min-w-0">
        <div className="flex items-center gap-2 text-[10px] font-semibold uppercase tracking-[0.22em] text-[#9d7bff]">
          {Icon ? <Icon className="h-4 w-4" /> : null} {eyebrow}
        </div>
        <h1 className="mt-2 text-4xl font-bold text-white sm:text-5xl" data-testid="page-title">{title}</h1>
        {keywords.length > 0 && (
          <div className="mt-1 text-3xl font-extrabold tracking-tight sm:text-4xl">
            <RotatingKeyword words={keywords} />
          </div>
        )}
        {intro ? <p className="mt-3 max-w-2xl text-base text-zinc-400" data-testid="page-intro">{intro}</p> : null}
      </div>
      {aside ? <div className="shrink-0">{aside}</div> : null}
    </div>
  </div>
);

export default PageHero;
